import { Facebook, Instagram, Pinterest, TwitterX } from '@rover/icons';
import { Link } from '@rover/kibble/core';
import { useTheme } from '@rover/kibble/themes';

type Props = {
  brandIcon: string | undefined;
  href: string;
};

const MarketingSocialIcon = ({ brandIcon, href }: Props): JSX.Element | null => {
  const { colors, space } = useTheme();

  let Logo: React.FC<React.SVGProps<SVGSVGElement>> | undefined;
  let brandColor: string | undefined;
  switch (brandIcon) {
    case 'facebook-footer':
      Logo = Facebook;
      brandColor = colors.brand.facebook.toString();
      break;
    case 'instagram-footer':
      Logo = Instagram;
      brandColor = colors.brand.instagram.toString();
      break;
    case 'twitter-footer':
      Logo = TwitterX;
      brandColor = colors.brand.x.toString();
      break;
    case 'pinterest-footer':
      Logo = Pinterest;
      brandColor = colors.brand.pinterest.toString();
      break;
    default:
      break;
  }

  if (!Logo || !brandColor) return null;
  return (
    <Link
      sx={{
        '&:not(:first-child)': {
          marginLeft: space['1x'],
        },
        '&:focus, &:hover': {
          textDecoration: 'none',
        },
      }}
      href={href}
      aria-label={brandIcon}
    >
      <Logo fill={brandColor} />
    </Link>
  );
};

export default MarketingSocialIcon;
